import React from "react";
import { Dialog, DialogContent, DialogActions, Button, IconButton } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import CloseIcon from "@material-ui/icons/Close";
import Lottie from "react-lottie";
import taibLoaderAnimation from "../assets/svg/TaibLoader.json";
import { useHistory, useLocation } from "react-router-dom";
import { returnToken } from "../../utils/helper";

const useStyles = makeStyles((theme) => ({
  dialog: {
    "& .MuiBackdrop-root": {
      backgroundColor: "rgba(0, 0, 0, 0.75)",
    },
    "& .MuiDialog-paper": {
      borderRadius: "16px",
      padding: "24px",
      maxWidth: "475px",
      width: "100%",
    },
  },
  content: {
    padding: "24px 0",
    textAlign: "center",
  },
  lottieContainer: {
    display: "flex",
    justifyContent: "center",
    marginBottom: "24px",
  },
  title: {
    fontSize: "24px",
    fontWeight: 700,
    lineHeight: "32px",
    color: "#1a1a1a",
    marginBottom: "16px",
  },
  description: {
    fontSize: "14px",
    fontWeight: 400,
    lineHeight: "24px",
    color: "#4a4a4a",
    marginBottom: "8px",
  },
  actions: {
    padding: "0",
    justifyContent: "center",
  },
  button: {
    backgroundColor: "#2d6a6a",
    color: "#ffffff",
    borderRadius: "8px",
    padding: "12px 48px",
    fontSize: "16px",
    fontWeight: 500,
    textTransform: "none",
    minWidth: "240px",
    "&:hover": {
      backgroundColor: "#235252",
    },
  },
  closeButton: {
    position: "absolute",
    right: "8px",
    top: "8px",
    color: "#4a4a4a",
  },
}));

const MigrationModal = ({ open, migratedLink, isAuthorized, userEmail, onClose }) => {
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();

  // Additional safety check - don't render if we don't have a migration link
  if (!migratedLink || migratedLink.trim() === "") {
    return null;
  }

  // Don't render if modal is not open
  if (!open) {
    return null;
  }

  const lottieOptions = {
    loop: true,
    autoplay: true,
    animationData: taibLoaderAnimation,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  const handleContinue = () => {
    if (!migratedLink) return;

    window.location.href = isAuthorized && userEmail ? `${migratedLink}${migratedLink.includes('?') ? '&' : '?'}email=${encodeURIComponent(userEmail)}` : migratedLink;
  };


  const handleClose = () => {
    // Redirect logged-in users to My-Appointments page if not already there
    if (isAuthorized && !location.pathname.includes('my-Appointments')) {
      history.push(`${returnToken("my-Appointments")}`);
    }

    if (onClose) {
      onClose();
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      className={classes.dialog}
      aria-labelledby="migration-modal-title"
      aria-describedby="migration-modal-description"
      disableBackdropClick={false}
      disableEscapeKeyDown={false}
      keepMounted={false}
    >
      <IconButton
        aria-label="close"
        className={classes.closeButton}
        onClick={handleClose}
      >
        <CloseIcon />
      </IconButton>
<DialogContent className={classes.content}>
        <div className={classes.lottieContainer}>
          <Lottie options={lottieOptions} height={120} width={120} />
        </div>
        <div className={classes.title}>
          We've Updated Your Experience
        </div>
        <p className={classes.description}>
          We've launched an improved version of our platform with a better and easier user experience.
        </p>
        <p className={classes.description}>
          Please continue to the new site to access your account and services.
        </p>
      </DialogContent>
      <DialogActions className={classes.actions}>
        <Button
          onClick={handleContinue}
          className={classes.button}
          variant="contained"
        >
          Continue to the new site
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default MigrationModal;
